export enum TableFilterType {
  Boolean,
  Currency,
  DateRange,
  DateTimeRange,
  MultiSelect,
  Number,
  Select,
  Text,
}
